<template>
    <div>
        <div class="d-flex justify-content-center align-items-center">
            <b-row class="w-100">
                <b-col cols="12" md="12" lg="12">
                    <b-card class="p-0 m-0" style="box-shadow: none;">

                        <b-card-body class="text-center" style="padding: 0; margin: 0;">
                            <div v-if="!isExpired">
                                <span class="h5">
                                    Hemos enviado una solicitud de autorización a tu dispositivo móvil, por favor
                                    revisar que sea el mismo código.
                                </span>
                                <br>
                                <br>
                                <span class="h1 ">
                                    <strong>{{ ultimos4 }}</strong>
                                </span>

                                <div class="mt-5">
                                    <ul class="list-unstyled text-left text-muted">
                                        <li>
                                            <p>
                                                <i class="fa-solid fa-circle-check text-success"></i>
                                                Revisa las notificaciones en tu celular
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <i class="fa-solid fa-circle-check text-success"></i>
                                                Confirma tu identidad
                                            </p>
                                        </li>
                                    </ul>
                                </div>

                                <div class="mb-4">
                                    <small class="text-muted h4">
                                        Tiempo restante:
                                        <span class="font-weight-bold"
                                            :class="timeRemaining <= 30 ? 'text-danger' : 'text-success'">
                                            {{ formatTime(timeRemaining) }}
                                        </span>
                                    </small>
                                    <b-progress :value="progressValue"
                                        :variant="timeRemaining <= 30 ? 'danger' : 'success'" class="mt-2"
                                        height="6px"></b-progress>
                                </div>
                            </div>

                            <div v-else class="mb-4">
                                <i icon="fa-solid fa-triangle-exclamation text-warning" class="mb-3"></i>
                                <p class="text-warning mb-3 lead">
                                    La solicitud de autorización ha expirado
                                </p>
                                <p class="text-muted">
                                    No se recibió respuesta en el tiempo esperado. Puedes enviar una nueva solicitud.
                                </p>
                                <div class="d-grid gap-2">
                                    <b-button variant="primary" size="lg" @click="renviarCodigo" :disabled="isResending"
                                        class="mb-2">
                                        Enviar Nueva Solicitud
                                    </b-button>

                                </div>
                            </div>


                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <!-- Toast para notificaciones -->
        <b-toast id="auth-toast" :title="toastTitle" :variant="toastVariant" solid auto-hide-delay="3000">
            {{ toastMessage }}
        </b-toast>
    </div>
</template>

<script>
export default {
    name: 'MobileAuthorizationPrompt',

    props: {
        initialTimeLimit: {
            type: Number,
            default: 60 // 2 minutos por defecto
        },
        codigo: {
            type: String,
        }
    },

    emits: ['resend-request', 'cancel-request', 'timeout', 'authorized'],

    data() {
        return {
            isResending: false,
            isExpired: false,
            timeRemaining: this.initialTimeLimit,
            showTroubleshooting: false,
            toastTitle: '',
            toastMessage: '',
            toastVariant: 'success',
            countdownTimer: null
        }
    },

    computed: {
        progressValue() {
            return (this.timeRemaining / this.initialTimeLimit) * 100
        },
        ultimos4() {
            return this.codigo.replace(/-/g, '').slice(0, 4).toUpperCase();
        }
    },

    methods: {
        formatTime(seconds) {
            const mins = Math.floor(seconds / 60)
            const secs = seconds % 60
            return `${mins}:${secs.toString().padStart(2, '0')}`
        },

        startCountdown() {
            this.countdownTimer = setInterval(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--
                } else {
                    this.handleTimeout()
                }
            }, 1000)
        },

        stopCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
        },

        handleTimeout() {
            this.stopCountdown()
            this.$emit('cerrarConexion')
            this.isExpired = true
        },

        async renviarCodigo() {
            this.isResending = true

            try {
                await this.$emit('renviarCodigo')

                // Resetear estado
                this.isExpired = false
                this.timeRemaining = this.initialTimeLimit
                this.showTroubleshooting = false

                // Reiniciar countdown
                this.startCountdown()


            } catch (error) {
                this.showToast('Error', 'No se pudo enviar la solicitud. Intenta nuevamente.', 'danger')
            } finally {
                this.isResending = false
            }
        },

        cancelRequest() {
            this.stopCountdown()
            this.$emit('cancel-request')
        },

        showToast(title, message, variant = 'success') {
            this.toastTitle = title
            this.toastMessage = message
            this.toastVariant = variant

            // Usar nextTick para asegurar que el toast se muestre
            this.$nextTick(() => {
                this.$bvToast.show('auth-toast')
            })
        },

        // Simular autorización exitosa (para testing)
        simulateAuthorization() {
            this.stopCountdown()
            this.showToast('¡Autorizado!', 'Inicio de sesión autorizado exitosamente', 'success')
            this.$emit('authorized')
        }
    },

    mounted() {
        this.startCountdown()

        // Simular autorización después de 10 segundos (solo para demo)
        // setTimeout(() => {
        //   this.simulateAuthorization()
        // }, 10000)
    },

    beforeUnmount() {
        this.stopCountdown()
    }
}
</script>
<style scoped>
.card {
    max-width: 100%;
    transition: transform 0.2s ease-in-out;
}


.list-unstyled li {
    padding: 0.25rem 0;
}

.progress {
    border-radius: 10px;
    background-color: white;
}

.btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
}

.btn:hover {
    transform: translateY(-1px);
}

.alert {
    border-radius: 8px;
}
</style>